module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8221d1ce26995074b5cb5c10896e0392.gif";